import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import { Page } from 'components'
import { useAuth } from 'hooks/useAuth'
import { getPrimeiroNome } from 'utils/helpers'
import useStyles from './DashboardDefault.styles'
import { useDashboard } from './hooks/useDashboard'
import { useDashboardModal } from './hooks/useDashboardModal'
import {
  DashboardLineChart,
  DashboardKpiCell,
  DashboardTableSection,
  DashboardConfigModal
} from './components'

/**
 * Main dashboard container/view. 
 * Composes sub-elements and binds dynamic hooks for settings and database operations.
 */
export const DashboardDefault = () => {
  const classes = useStyles()
  const { currentUser } = useAuth()

  // Custom hook to manage dynamic queries and configuration updates
  const {
    config,
    kpiData,
    chartData,
    tableData,
    processingKpis,
    processingCharts,
    processingTable,
    updateCellConfig,
  } = useDashboard()

  // Custom hook to manage settings modal interaction and sector queries
  const {
    modalOpen,
    modalSection,
    selectedType,
    setSelectedType,
    selectedSector,
    setSelectedSector,
    sectors,
    loadingSectors,
    handleOpenConfig,
    handleConfirmConfig,
    setModalOpen,
  } = useDashboardModal(config, updateCellConfig)

  const userName = currentUser ? getPrimeiroNome(currentUser.nome) : 'Usuário'

  return (
    <Page className={classes.root} title="SIGEP - Página Inicial">

      <div className={classes.titleContainer}>
        <Typography className={classes.welcomeTitle} variant="h1">
          Olá, {userName}
        </Typography>
        <Typography className={classes.welcomeSubtitle} variant="body1">
          Bem-vindo ao painel operacional do SIGEP. Personalize seu painel passando o cursor sobre cada bloco.
        </Typography>
      </div>

      <Grid container spacing={3} className={classes.kpiGrid}>
        {config.kpis.map((cell, idx) => (
          <DashboardKpiCell
            key={idx}
            cell={cell}
            dataItem={kpiData[idx]}
            isProcessing={processingKpis[idx]}
            onConfigClick={() => handleOpenConfig('kpis', idx)}
          />
        ))}
      </Grid>

      <Grid container spacing={3} className={classes.chartsGrid}>
        {config.charts.map((cell, idx) => (
          <Grid item xs={12} md={6} key={idx}>
            <DashboardLineChart
              cell={cell}
              data={chartData[idx]}
              isProcessing={processingCharts[idx]}
              onConfigClick={() => handleOpenConfig('charts', idx)}
              height={320}
            />
          </Grid>
        ))}
      </Grid>

      {/* 4. Base Table: Latest activities */}
      <DashboardTableSection
        cell={config.tables[0]}
        tableData={tableData}
        isProcessing={processingTable}
        onConfigClick={() => handleOpenConfig('tables', 0)}
      />

      {/* Dashboard Configuration Form Modal */}
      <DashboardConfigModal
        open={modalOpen}
        section={modalSection}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirmConfig}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        selectedSector={selectedSector}
        setSelectedSector={setSelectedSector}
        sectors={sectors}
        loadingSectors={loadingSectors}
      />
    </Page>
  )
}
